import React from "react";
import { Link } from "react-router-dom";

const Cards = ({ title, description, image, link, liveLink, git }) => {

  const isUXUI = title.includes("UX/UI");
  
  return (
    <div
      className="md:h-[450px] rounded-lg mt-10  flex flex-col justify-between "
      style={{ boxShadow: "0px 0px 1rem rgba(255, 255, 255, 0.25)" }}
    >
      <div className=" p-4 text-white ">
        <div className="relative">
          <img
            src={image}
            alt={title}
            className="w-full md:h-40 object-cover rounded-t-lg "
          />
          <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/80 to-transparent"></div>
        </div>

        <h2 className="md:text-xl font-semibold mt-4">{title}</h2>
        <p className="text-slate-400 mt-2 text-sm md:text-base">
          {description}
        </p>
      </div>
      <div className="flex justify-between p-5 text-slate-50 font-light">
        {!isUXUI ? (
          <Link to={liveLink} target="_blank">
            Live Link
          </Link>
        ) : (
          <Link to={link} target="_blank">
            See Project
          </Link>
        )}
        <Link to={git} target="_blank">
          {isUXUI ? "Adobe XD" : "GitHub"}
        </Link>
      </div>
    </div>
  );
};

export default Cards;
